import React, { useEffect } from 'react'
import { SimpleGrid, Card, Text, Group, ThemeIcon, Title, Box, rem } from '@mantine/core'
import {
    IconMap,
    IconAnchor,
    IconFlag,
    IconBuildingArch,
    IconBuildingCommunity,
    IconCoin,
    IconStar,
    IconBarcode,
    IconShip,
    IconTruck,
    IconCategory,
    IconTemplate,
    IconSitemap,
    IconCreditCard,
    IconLanguage
} from '@tabler/icons-react'
import { useNavigate, useOutlet } from 'react-router-dom'
import classes from './CommonAndGlobalSettings.module.css'
import AuthLayout from '../../../../layout/AuthLayout'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'

const CommonAndGlobalSettings = () => {
    const outlet = useOutlet()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(updateRoute({
            data: [
                { label: '/', route: null },
                { label: 'Common & Global Settings', route: null }
            ]
        }))
    }, [dispatch])

    if (outlet) {
        return outlet
    }

    const commonSettings = [
        { title: 'Area', subtitle: 'Manage geographical areas and regions', icon: IconMap, route: '/settings/area' },
        { title: 'Port', subtitle: 'Configure shipping ports and terminals', icon: IconAnchor, route: '/settings/port' },
        { title: 'Country', subtitle: 'List of supported countries and regulations', icon: IconFlag, route: '/settings/country-list' },
        { title: 'Province', subtitle: 'Regional divisions and state management', icon: IconBuildingArch, route: '/settings/province' },
        { title: 'City', subtitle: 'City-level configurations and zones', icon: IconBuildingCommunity, route: '/settings/city' },
        { title: 'Currencies', subtitle: 'Exchange rates and currency formats', icon: IconCoin, route: '/settings/currency' },
        { title: 'Review', subtitle: 'Customer reviews and feedback settings', icon: IconStar, route: '/settings/review' },
    ]

    const globalSettings = [
        { title: 'Payment Channels', subtitle: 'Manage available payment channels', icon: IconCreditCard, route: '/settings/payment-channels' },
        { title: 'HS Codes', subtitle: 'Harmonized System codes for customs', icon: IconBarcode, route: '/settings/hscodes' },
        { title: 'International Shipping Rates', subtitle: 'Zone-based global shipping tariffs', icon: IconShip, route: '/settings/international-shipping-rates' },
        { title: 'Domestic Shipping Rate', subtitle: 'Local delivery costs and methods', icon: IconTruck, route: '/settings/domestic-shipping-rates' },
        { title: 'Product Category', subtitle: 'Manage product categories and hierarchy', icon: IconSitemap, route: '/settings/product-category' },
        { title: 'Category Rules', subtitle: 'Restrictions and rules for categories', icon: IconCategory, route: '/settings/category-rules' },
        { title: 'Product Rules', subtitle: 'Validation and attribute rules for products', icon: IconTemplate, route: '/settings/product-rules' },
        { title: 'Category Mapping', subtitle: 'Map local categories to external standards', icon: IconSitemap, route: '/settings/category-mapping' },
        { title: 'Payment Settings', subtitle: 'Payment gateways and transaction methods', icon: IconCreditCard, route: '/settings/payment-settings' },
        { title: 'Language List', subtitle: 'Supported languages and translations', icon: IconLanguage, route: '/settings/language-list' },
    ]

    const SettingCard = ({ item }) => (
        <Card
            withBorder
            padding="lg"
            radius="md"
            className={classes.card}
            onClick={() => navigate(item.route)}
        >
            <Group justify="space-between" mb="xs">
                <Text fw={600} fz="lg" className={classes.title}>
                    {item.title}
                </Text>
                <ThemeIcon
                    size="xl"
                    radius="md"
                    variant="light"
                    color="red"
                >
                    <item.icon style={{ width: rem(28), height: rem(28) }} stroke={1.5} />
                </ThemeIcon>
            </Group>

            <Text c="dimmed" size="sm" mt="sm">
                {item.subtitle}
            </Text>
        </Card>
    )

    return (
        <AuthLayout>
            <Box>
                <Box mb={40}>
                    <Title order={2} mb="lg">Common Settings</Title>
                    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
                        {commonSettings.map((item) => (
                            <SettingCard key={item.title} item={item} />
                        ))}
                    </SimpleGrid>
                </Box>

                <Box>
                    <Title order={2} mb="lg">Global Settings</Title>
                    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
                        {globalSettings.map((item) => (
                            <SettingCard key={item.title} item={item} />
                        ))}
                    </SimpleGrid>
                </Box>
            </Box>
        </AuthLayout>
    )
}

export default CommonAndGlobalSettings
